@if (banners().length) {
  <section class="anomaly-banners" aria-label="Anomalies en cours">
    @for (banner of banners(); track banner.id) {
      <app-anomaly-banner
        [anomaly]="banner"
        [state]="banner.displayState"
        (collapse)="remember(banner.id, 'COLLAPSED')"
        (expand)="remember(banner.id, 'EXPANDED')"
        (dismiss)="remember(banner.id, 'CLOSED')"
      ></app-anomaly-banner>
    }
  </section>
}
